"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable @typescript-eslint/no-non-null-assertion */
// @ts-nocheck
const WebGLTile_js_1 = __importDefault(require("ol/layer/WebGLTile.js"));
const GeoTIFF_1 = __importDefault(require("ol/source/GeoTIFF"));
const Utils_1 = require("../Utils");
const proj_1 = require("ol/proj");
const CenterUtility_1 = require("../models/CenterUtility");
const ol_1 = require("ol");
class RasterBuilder {
    constructor(map = new ol_1.Map()) {
        this.map = map;
    }
    get projections() {
        return { dataProjection: 'EPSG:4326', featureProjection: 'EPSG:3857' };
    }
    centerZone(extent) {
        (0, CenterUtility_1.center)(this.map, extent);
    }
    async drawRaster(sourceOptions, layerOptions, center = false) {
        if ((0, Utils_1.findLayerById)(layerOptions.name, this.map)) {
            const layers = (0, Utils_1.filterLayersById)('raster-layer', this.map);
            layers.forEach((layer) => {
                layer.setVisible(false);
            });
            (0, Utils_1.findLayerById)(layerOptions.name, this.map).setVisible(true);
            const rasterView = await (0, Utils_1.findLayerById)(layerOptions.name, this.map).getSource().getView();
            const extent = rasterView.extent;
            const extentInProjection = (0, proj_1.transformExtent)(extent, 'EPSG:4326', 'EPSG:3857');
            if (center)
                this.centerZone(extentInProjection);
        }
        else {
            const sourceObjOptions = Object.assign(Object.assign(Object.assign(Object.assign({}, (sourceOptions.url && { url: sourceOptions.url })), (sourceOptions.nodata !== null && sourceOptions.nodata !== undefined && { nodata: sourceOptions.nodata })), (sourceOptions.max !== null && sourceOptions.max !== undefined && { max: sourceOptions.max })), (sourceOptions.min !== null && sourceOptions.min !== undefined && { min: sourceOptions.min }));
            const source = new GeoTIFF_1.default({
                sources: [sourceObjOptions],
                interpolate: false,
            });
            const rasterView = await source.getView();
            const extent = rasterView.extent;
            const extentInProjection = (0, proj_1.transformExtent)(extent, 'EPSG:4326', 'EPSG:3857');
            const layer = new WebGLTile_js_1.default({ source: source, visible: true, cacheSize: 150, preload: 3, style: layerOptions.color ? { color: layerOptions.color } : null });
            (0, Utils_1.addLayerToMap)(layer, layerOptions.name, layerOptions.zindex, this.map);
            if (center)
                this.centerZone(extentInProjection);
        }
    }
}
exports.default = RasterBuilder;
